export class UnderwritingQuestionModel {
  question: string;
  mappedQuestion?: string;
  id: number;
  isAnswerYes?: boolean;
}
